import React from "react";
import { HeadRow, useDayPicker } from "react-day-picker";
/**
 * https://github.com/gpbl/react-day-picker/tree/main/src/components/Head
 */
function TableHead() {
    var _a;
    const { classNames, styles, components } = useDayPicker();
    const HeadRowComponent = (_a = components === null || components === void 0 ? void 0 : components.HeadRow) !== null && _a !== void 0 ? _a : HeadRow;
    return (React.createElement("thead", { style: styles.head, className: classNames.head, "aria-hidden": true },
        React.createElement(HeadRowComponent, null)));
}
export default TableHead;
//# sourceMappingURL=TableHead.js.map